export default __webpack_public_path__ + "static/media/album.18f5be59.svg";